import React, { useState } from 'react';
import illustration from '@/images/survey/call-illustration.svg';
import { updateUserModalStatus } from '@/services/user.service';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import ModalComponent from '@/components/common-components/ModalComponent/ModalComponent';
import RightArrow from '@/components/Icons/icons/RightArrow';

import '@/components/common-components/ModalComponent/_modalComponent.scss';

import OnboardingEndModal from '@/components/common-components/OnboardingComponents/OnboardingEndModal';

export default function AccountActiveModal({
  show,
  setShow,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [showOnboardingEndModal, setShowOnboardingEndModal] = useState(false);
  const navigate = useNavigate();

  const disableModal = async () => {
    await updateUserModalStatus({ postActiveWelcomeModal: false });
    setShow(false);
  };

  const redirectToOnboardingSession = async () => {
    await updateUserModalStatus({ postActiveWelcomeModal: false });
    navigate('/book-session?next=onboarding');
  };

  const handleOnboardingEndModalClose = () => {
    setShowOnboardingEndModal(false);
    disableModal();
  };

  return showOnboardingEndModal ? (
    <OnboardingEndModal show={showOnboardingEndModal} onClose={handleOnboardingEndModalClose} />
  ) : (
    <ModalComponent
      show={show}
      width={1020}
      onClose={() => {}}
      outsideClickClose={false}
      style={{ padding: '0px' }}
      bodyStyle={{ padding: '32px' }}>
      <div className="survey-final-container">
        <div className="survey-final-content">
          <div className="survey-final-left" style={{ width: '490px' }}>
            <div className="survey-final-text" style={{ paddingBottom: '32px' }}>
              <div className="title" style={{ fontSize: '32px', fontWeight: '500' }}>
                Welcome to SARAL! <br /> Your account is active 🎉
              </div>
              <p className="description" style={{ fontSize: '18px' }}>
                Congrats on completing a successful trial and joining the SARAL squad.
                <br />
                <br />
                Our happiness team will assist you over the course of your journey building your influencer marketing
                program. Reach out to us in the support chat on the bottom right corner if you need help while you work.{' '}
                <br />
                <br />
                If you don&apos;t already have one scheduled, we recommend scheduling a call with our team of experts to
                get you scaled up fast.
                <br />
                <br />
                Otherwise, feel free to explore on your own and we&apos;ll speak soon!
              </p>
            </div>
          </div>
          <div
            className="survey-final-illustration"
            style={{ width: '420px', height: '400px', position: 'relative', top: '110px' }}>
            <img src={illustration} alt="illustration" width={420} height={365} />
          </div>
        </div>
        <div className="center gap-6">
          <ButtonComponent
            onClick={() => {
              setShowOnboardingEndModal(true);
              setShow(false);
            }}
            style={{ flex: 1 }}
            variant="secondary">
            I&apos;ll explore on my own
          </ButtonComponent>
          <ButtonComponent style={{ flex: 1 }} onClick={redirectToOnboardingSession}>
            Book Strategy Call <RightArrow color={'white'} height={26} width={18} />
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
}
